<template>
  <div class="form">
     <ui-input
       :type="'password'"
       :placeholder="t('fields.password')"
       :rules="[isPasswordValid]"
       v-model="password"
     />
     <ui-input
       :type="'password'"
       :placeholder="t('fields.passwordConfirm')"
       :rules="[compareStrings]"
       v-model="passwordConfirm"
     />
    <ui-button
        class="form__button"
        :isLoading="isLoading"
        :isDisabled="!isFormValid"
        @click="confirmResetPassword"
    >
      {{ t('buttons.reset') }}
    </ui-button>
  </div>
</template>

<script setup>
import UiInput from "@/components/ui/ui-input.vue";
import {useI18n} from "vue-i18n";
import {isPasswordValid} from "@/core/rules/textFieldRules.js";
import {computed, ref} from "vue";
import UiButton from "@/components/ui/ui-button.vue";
import {Auth} from "@/core/api/auth.js";
import {ElNotification} from "element-plus";
import {useRoute, useRouter} from "vue-router";

const {t} = useI18n()
const route = useRoute()
const router = useRouter()

const uid = computed(() => {
  return route.query.uid ? route.query.uid : ''
})
const token = computed(() => {
  return route.query.token ? route.query.token : ''
})

const password = ref('')
const passwordConfirm = ref('')

const isLoading = ref(false)

const compareStrings = (v) => {
  if (v === password.value) return true
  return t('errors.compare')
}

const isFormValid = computed(() => {
  return (
    isPasswordValid(password.value) === true &&
    compareStrings(passwordConfirm.value) === true
  )
})

const confirmResetPassword = async () => {
  isLoading.value = true

  const res = await Auth.confirmResetPassword(uid.value, token.value, password.value, passwordConfirm.value)

  if (!res.errors) {
    await router.push({
      name: 'login',
      params: {
        locale: localStorage.getItem('fpt-user-locale') || 'en-gb'
      }
    })

    ElNotification({
      message: t('popup.successNewPassword'),
      type: 'success'
    })
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }

  isLoading.value = false
}
</script>

<style lang="scss" scoped>
.form {
  position: relative;
  z-index: 1;
  width: 585px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;

    & p {
      color: #5B194F;
      font-size: 16px;
      font-weight: 600;
    }
  }

  &__button {
    width: fit-content;
    padding-inline: 50px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 7px;

    &-link {
      transition: 0.2s;
      color: #FFCF96;
      font-size: 14px;
      font-weight: 500;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;

      &:hover {
        color: #fcb86d;
      }
    }

    &-text {
      transition: 0.2s;
      color: #6C6C6C;
      font-size: 14px;
      font-weight: 400;

      &:hover {
      color: #333333;
      }
    }
  }
}

@media (max-width: 650px) {
  .form {
    width: 100%;
  }
}
</style>